import { CHART_COLOR_BY_SCORE, DEFAULT_COLOR } from '../BeFi20.meta';

export const getGradientColoursByScore = (score?: number) => {
  if (score === undefined) {
    return DEFAULT_COLOR;
  }

  const colorKey = Object.keys(CHART_COLOR_BY_SCORE).find(key => score <= +key);

  return colorKey ? CHART_COLOR_BY_SCORE[colorKey] : DEFAULT_COLOR;
};
